(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["le-core-sidemenu-left"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const mainMenuView = document.querySelector('.main-menu-view');
    const subcategoryViews = document.querySelectorAll('.subcategory-view');
    const subsubcategoryViews = document.querySelectorAll('.subsubcategory-view');
    const categoryHeaders = document.querySelectorAll('.category-header');
    const backButtons = document.querySelectorAll('.back-btn');
    const subToggleButtons = document.querySelectorAll('.sub-toggle-btn');
    const subBackButtons = document.querySelectorAll('.sub-back-btn');
    const clickableTitles = document.querySelectorAll('.clickable-title');

    const setNavHeight = () => {
      const sidemenuNav = document.querySelector('.sidemenu_nav_main');
      const mainMenuHeight = mainMenuView.scrollHeight;
      let maxSubcategoryHeight = 0;
      
      subcategoryViews.forEach((view) => {
        if (view.scrollHeight > maxSubcategoryHeight) {
          maxSubcategoryHeight = view.scrollHeight;
        }
      });

      subsubcategoryViews.forEach((view) => {
        if (view.scrollHeight > maxSubcategoryHeight) {
          maxSubcategoryHeight = view.scrollHeight;
        }
      });

      const minHeight = Math.max(mainMenuHeight, maxSubcategoryHeight);
      sidemenuNav.style.minHeight = minHeight + 'px';
    };

    setNavHeight();
    window.addEventListener('resize', setNavHeight);

    categoryHeaders.forEach((header) => {
      const category = header.closest('.nav-category');
      if (category) {
        const categoryId = category.dataset.category;
        const subcategoryView = document.querySelector(`.subcategory-view[data-view="${categoryId}"]`);

        if (subcategoryView) {
          header.addEventListener('click', function (e) {
            if (e.target.tagName === 'A') return;

            void mainMenuView.offsetWidth;
            subcategoryView.classList.add('active');

            setTimeout(() => {
              mainMenuView.classList.remove('active');
            }, 50);
          });
        }
      }
    });

    clickableTitles.forEach((title) => {
      title.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        
        const submenuItem = this.closest('.submenu-item');
        if (submenuItem) {
          const subcategoryId = submenuItem.dataset.subcategory;
          const parentId = submenuItem.dataset.parent;
          const subsubcategoryView = document.querySelector(`.subsubcategory-view[data-view="${subcategoryId}"][data-parent="${parentId}"]`);
          const currentSubcategoryView = document.querySelector(`.subcategory-view[data-view="${parentId}"]`);

          if (subsubcategoryView && currentSubcategoryView) {
            void currentSubcategoryView.offsetWidth;
            subsubcategoryView.classList.add('active');

            setTimeout(() => {
              currentSubcategoryView.classList.remove('active');
            }, 50);
          }
        }
      });
    });

    subToggleButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        
        const submenuItem = this.closest('.submenu-item');
        if (submenuItem) {
          const subcategoryId = submenuItem.dataset.subcategory;
          const parentId = submenuItem.dataset.parent;
          const subsubcategoryView = document.querySelector(`.subsubcategory-view[data-view="${subcategoryId}"][data-parent="${parentId}"]`);
          const currentSubcategoryView = document.querySelector(`.subcategory-view[data-view="${parentId}"]`);

          if (subsubcategoryView && currentSubcategoryView) {
            void currentSubcategoryView.offsetWidth;
            subsubcategoryView.classList.add('active');

            setTimeout(() => {
              currentSubcategoryView.classList.remove('active');
            }, 50);
          }
        }
      });
    });

    backButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const subcategoryView = this.closest('.subcategory-view');

        void subcategoryView.offsetWidth;
        mainMenuView.classList.add('active');

        setTimeout(() => {
          subcategoryView.classList.remove('active');
        }, 50);
      });
    });

    subBackButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const subsubcategoryView = this.closest('.subsubcategory-view');
        const parentId = this.dataset.parent;
        const parentSubcategoryView = document.querySelector(`.subcategory-view[data-view="${parentId}"]`);

        if (subsubcategoryView && parentSubcategoryView) {
          void subsubcategoryView.offsetWidth;
          parentSubcategoryView.classList.add('active');

          setTimeout(() => {
            subsubcategoryView.classList.remove('active');
          }, 50);
        }
      });
    });

    const currentPath = window.location.pathname;
    const allLinks = document.querySelectorAll('.submenu a');

    allLinks.forEach((link) => {
      if (link.getAttribute('href') === currentPath) {
        const subcategoryView = link.closest('.subcategory-view');
        const subsubcategoryView = link.closest('.subsubcategory-view');
        
        if (subsubcategoryView) {
          const parentId = subsubcategoryView.dataset.parent;
          const categoryElement = document.querySelector(`.nav-category[data-category="${parentId}"]`);
          if (categoryElement) {
            categoryElement.classList.add('current');
          }
        } else if (subcategoryView) {
          const categoryId = subcategoryView.dataset.view;
          const categoryElement = document.querySelector(`.nav-category[data-category="${categoryId}"]`);
          if (categoryElement) {
            categoryElement.classList.add('current');
          }
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-main-article-seo-barbie"]) return;
  try {
    
  $('.expandlist').click(function(e) {
    e.preventDefault();
    $(this).parent().toggleClass('openlist');
  })

  $('.opensteps').click(function(e) {
    e.preventDefault();
    $(this).closest(".get-the-look").children('.listcheck').toggleClass('openlist');
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-main-article-seo-expanded"]) return;
  try {
    
  $('.expandlist').click(function(e) {
    e.preventDefault();
    $(this).parent().toggleClass('openlist');
  })

  $('.opensteps').click(function(e) {
    e.preventDefault();
    $(this).closest(".get-the-look").children('.listcheck').toggleClass('openlist');
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-main-product"]) return;
  try {
    
  $('[data-load-block]').click(function () {
    var target = $(this).data('load-block');
    $('.extrapdpblocks section')
      .not('#' + target)
      .removeClass('selected');
    $('#' + target).toggleClass('selected');
  });

  $(window).on('load', function () {
    if ($(window).width() < 700) {
      var splidePdpimages = new Splide( '.pdpimages', {
      type   : 'loop',
      drag   : 'free',
      snap   : true,
      arrows : false,
      pagination : true,
      autoplay: true,
      perPage: 1,
      speed: 1000,
      } );

      splidePdpimages.mount();
    } else {
      // alert("Carousel not needed on Desktop");
    }
  });

  // Shade category filter - add this once
  $('a[data-shade-group]').click(function(event) {
    event.preventDefault();
    var choice = $(this).data('shade-group');
    $(".shadecategorychooser a").removeClass("selectedcategory");
    $(this).addClass("selectedcategory");
    $('.category').show();
    if(choice !== 'all') {
      $('.category').not('.'+ choice).hide();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-announcement-new-user-ribbon"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function ($) {
    var $announcements = $('.announcements[data-new-visitor-only="true"]');

    if ($announcements.length === 0) return;

    var hasVisited = localStorage.getItem('le_has_visited');

    if (hasVisited) {
      $announcements.remove();
      return;
    }

    // New visitor - show banner
    try {
      if ($announcements.find('.announcementsNewUser .announcement').length > 0 && !$announcements.hasClass('is-initialized')) {
        var splideAnnouncementsNewUsers = new Splide( '.announcementsNewUser', {
        type   : 'loop',
        drag   : 'free',
        snap   : true,
        arrows : false,
        pagination : false,
        autoplay: true,
        perPage: 1,
        speed: 1500,
      });

      splideAnnouncementsNewUsers.mount();
    }
      localStorage.setItem('le_has_visited', 'true');
    } catch (e) {
      console.log('Slick error:', e);
      // Still set localStorage even if slick fails
      localStorage.setItem('le_has_visited', 'true');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-cursor"] && !Shopify.designMode) return;
  try {
    
  $(document).on("mousemove", function(e) {
    $("#topsecretcursor").css({
      left: e.pageX + 15,
      top: e.pageY + 12
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-flexible-panel-row"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const revealElements = document.querySelectorAll('.reveal');

    revealElements.forEach(function(reveal) {
      const primaryImage = reveal.querySelector('.primary-image');
      const hoverImage = reveal.querySelector('.hover-image');

      if (hoverImage) {
        primaryImage.classList.add('has-hover');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-latest-portfolio"] && !Shopify.designMode) return;
  try {
    
var splidePortfolio = new Splide( '.latestportfolio', {
  type   : 'loop',
  focus  : 'center',
  drag   : 'free',
  lazyLoad: 'nearby',
  gap: 10,
  snap   : true,
  arrows : false,
  pagination : false,
  autoplay: true,
  perPage: 6,
  speed: 1000,
  start  : 0,
  breakpoints: {
    700: {
      perPage: 2,
    },
  },
} );

splidePortfolio.mount();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-my-videos"] && !Shopify.designMode) return;
  try {
    
var splideVideos = new Splide( '.latestvideos', {
  type   : 'loop',
  focus  : 'center',
  drag   : 'free',
  lazyLoad: 'nearby',
  gap: 10,
  snap   : true,
  arrows : false,
  pagination : false,
  autoplay: false,
  perPage: 4,
  start  : 0,
  breakpoints: {
    700: {
      perPage: 1.5,
    },
  },
});

splideVideos.mount();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-product-category-grid"] && !Shopify.designMode) return;
  try {
    
$('.subnavigation a').click(function (e) {
  const $link = $(this);
  const filtertag = $link.data('filtertag');
  const group = $link.closest('.subnavigation').data('filter-group');

  const $grid = $('.product-category-grid[data-filter-group="' + group + '"]');

  $grid.find('.stacked-collection').hide();
  $link.closest('.subnavigation').find('a').removeClass('highlight');

  if (filtertag != 'all') {
    $grid.find('.' + filtertag).show();
    $link.addClass('highlight');
  } else {
    $grid.find('.stacked-collection').show();
    $grid.find('.hide-on-all').hide();
  }

  $grid.find('.carousel').each(function () {
    if ($(this).hasClass('slick-initialized')) {
      $(this).slick('setPosition');
    }
  });
});

  $('.toggle-shades').click(function (e) {
    e.preventDefault();
    $(this).closest('.shades-container').toggleClass('showall');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-product-filters-eyeshadow-refills"] && !Shopify.designMode) return;
  try {
    
  $('.product-item-filter a').click(function (e) {
    // e.preventDefault();
    $('.product-item-filter a').removeClass('selected-filter');
    $(this).addClass('selected-filter');
    $('.product-item').hide();
    var target = $(this).data('tag');
    $('.' + target).show();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-product-filters-lips-2025"] && !Shopify.designMode) return;
  try {
    
  (function () {
    let activeFilters = {
      formulation: 'all',
      finish: 'all',
      colour: 'all',
      undertone: 'all',
    };

    document.querySelectorAll('.filter-toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        const filterType = this.getAttribute('data-filter');
        const dropdown = document.querySelector('[data-dropdown="' + filterType + '"]');

        document.querySelectorAll('.filter-dropdown').forEach(function (dd) {
          if (dd !== dropdown) {
            dd.classList.remove('active');
          }
        });
        document.querySelectorAll('.filter-toggle').forEach(function (t) {
          if (t !== toggle) {
            t.classList.remove('active');
          }
        });

        dropdown.classList.toggle('active');
        this.classList.toggle('active');
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.filter-item')) {
        document.querySelectorAll('.filter-dropdown').forEach(function (dd) {
          dd.classList.remove('active');
        });
        document.querySelectorAll('.filter-toggle').forEach(function (t) {
          t.classList.remove('active');
        });
      }
    });

    document.querySelectorAll('.filter-dropdown a[data-filter-type]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const filterType = this.getAttribute('data-filter-type');
        const tag = this.getAttribute('data-tag');

        activeFilters[filterType] = tag;

        const dropdown = this.closest('.filter-dropdown');
        dropdown.querySelectorAll('a').forEach(function (a) {
          a.classList.remove('selected-filter');
        });
        this.classList.add('selected-filter');

        applyFilters();

        dropdown.classList.remove('active');
        dropdown.previousElementSibling.classList.remove('active');
      });
    });

    document.querySelector('.mobile-filter-toggle').addEventListener('click', function () {
      this.classList.toggle('active');
      document.querySelector('.mobile-filter-panel').classList.toggle('active');
    });

    document.querySelectorAll('.mobile-filter-header').forEach(function (header) {
      header.addEventListener('click', function () {
        const filterType = this.getAttribute('data-mobile-filter');
        const content = document.querySelector('[data-mobile-content="' + filterType + '"]');

        this.classList.toggle('active');
        content.classList.toggle('active');
      });
    });

    document.querySelectorAll('.mobile-filter-content a[data-filter-type]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const filterType = this.getAttribute('data-filter-type');
        const tag = this.getAttribute('data-tag');

        activeFilters[filterType] = tag;

        const content = this.closest('.mobile-filter-content');
        content.querySelectorAll('a').forEach(function (a) {
          a.classList.remove('selected-filter');
        });
        this.classList.add('selected-filter');

        applyFilters();
      });
    });

    function applyFilters() {
      document.querySelectorAll('.product-item').forEach(function (product) {
        let shouldShow = true;

        Object.keys(activeFilters).forEach(function (filterType) {
          const filterValue = activeFilters[filterType];

          if (filterValue !== 'all') {
            if (!product.classList.contains(filterValue)) {
              shouldShow = false;
            }
          }
        });

        if (shouldShow) {
          product.style.display = '';
          product.classList.remove('hidden');
        } else {
          product.style.display = 'none';
          product.classList.add('hidden');
        }
      });
    }

    document.querySelectorAll('[data-sort]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const sortType = this.getAttribute('data-sort');

        const dropdown = this.closest('.filter-dropdown');
        dropdown.querySelectorAll('a').forEach(function (a) {
          a.classList.remove('selected-filter');
        });
        this.classList.add('selected-filter');

        console.log('Sort by:', sortType);

        dropdown.classList.remove('active');
        dropdown.previousElementSibling.classList.remove('active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-related-products"] && !Shopify.designMode) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=le-module-related-products&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    // alert(requestUrl);
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-sub-navigation"] && !Shopify.designMode) return;
  try {
    
  /* MOVED TO PRODUCT CATEGORY GRID
  $(document).ready(function($) {

    $('a[data-filtertag]').click(function(e) {

      $('.stacked-collection').hide();
      $('a[data-filtertag]').removeClass('highlight');

      var filtertag = $(this).data('filtertag');
      $('.'+filtertag).show();
      $(this).addClass('highlight');
    });

  });*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-module-table"] && !Shopify.designMode) return;
  try {
    
  $('button.toggle-table-btn, .close-table-link').click(function(){
    var closest = $(this).closest('.le-module-table').attr('id');
    $("#"+closest+" .table-wrapper").toggleClass("hidden");
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-popup-currency"]) return;
  try {
    
$('#localization_submit').remove();
$('#countrydropdown').on('change', function() {
  document.forms['localization_form'].submit();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-popup-product-referral"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      const popup = document.getElementById('recommendationPopup');
      if (popup) {
        popup.style.display = 'block';
        setTimeout(() => {
          popup.classList.add('is-active');
        }, 10);
      }
    }, 2000);

    const closeButtons = document.querySelectorAll(
      '.recommendation-popup__close, .recommendation-popup__button--secondary'
    );
    closeButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closePopup();
      });
    });

    const popup = document.getElementById('recommendationPopup');
    if (popup) {
      popup.addEventListener('click', function (event) {
        if (event.target === popup || event.target.classList.contains('recommendation-popup__overlay')) {
          closePopup();
        }
      });
    }
  });

  function closePopup() {
    const popup = document.getElementById('recommendationPopup');
    if (popup) {
      popup.classList.remove('is-active');
      setTimeout(() => {
        popup.style.display = 'none';
      }, 300);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-temp-pp-find-your-shade"] && !Shopify.designMode) return;
  try {
    
  $('.shadeslider').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    centerMode: true,
    responsive: [
    {
      breakpoint: 640,
      settings: {
      slidesToShow:3,
    }
    }]
  });
  $(".shadeslider").show();

  // Slide to shade when swatch is clicked
  $('a[data-slick-index]').on('click', function () {
    var slideno = $(this).data('slick-index');
    $('.shadeslider').slick('slickGoTo', slideno);
  });

  } catch(e) { console.error(e); }
})();
})();
